module.exports = __webpack_public_path__ + "static/media/p2.a8f57444.png";